import { Mc2CommandEnum } from '@/types/c2/c2.types';
import { BlastMode } from '@/types/sensor/sensors/blast.types';

import {
  CommonConfiguration,
  CommonSensorStatus,
  HostConfiguration,
  PortConfiguration,
  SensorTypeEnum,
  SpecificStateEnum,
} from './common.types';
import { Dfb6Mode } from './dfb6.types';
import { MajesSector } from './majes.types';

export interface Mc2Module {
  moduleId: number;
  name: string;
  active: boolean;
  enabled: boolean;

  // Unit: dBm
  minPower: number | null;
  maxPower: number | null;

  //Unit: Hz
  minFrequency: number | null;
  maxFrequency: number | null;
}

export interface Mc2SensorConfiguration extends CommonConfiguration, HostConfiguration, PortConfiguration {
  mc2StatusTimer: number;
}

export interface Mc2Sector {
  active: boolean;
  name: string;

  // Between 0 - 359
  orientation: number;
  // Between 0 - 359
  aperture: number;
  // Min 0
  range: number;
}

export enum OutputMode {
  CHARGE = 'CHARGE',
  OMNI = 'OMNI',
  DIRECTIVE = 'DIRECTIVE',
}

export const OutputModeValue: { [key in OutputMode]: 0 | 1 | 2 } = {
  [OutputMode.CHARGE]: 0,
  [OutputMode.OMNI]: 1,
  [OutputMode.DIRECTIVE]: 2,
} as const;

export type OutputModeValueType = (typeof OutputModeValue)[OutputMode];

export enum JammingStatus {
  OFF = 0,
  ON = 1,
  FORCED = 2,
}

export interface Mc2SensorStatusDto extends CommonSensorStatus {
  jammingStatus: JammingStatus;
  specificState: SpecificStateEnum.EMITTING | null;
}

export interface Mc2ModuleStatus {
  jamming: boolean | null;
  disconnectedAntenna: boolean | null;
  incorrectPower: boolean | null;
  moduleNotResponding: boolean | null;
  overPower: boolean | null;
  underPower: boolean | null;
  overHeat: boolean | null;
  fanFailure: boolean | null;
}

export type Mc2SectorConfigMap = {
  [SensorTypeEnum.DFB6]: Dfb6Mode;
  [SensorTypeEnum.MAJES]: MajesSector;
  [SensorTypeEnum.BLAST]: BlastMode;
};

export type SectorConfigKey = keyof Mc2SectorConfigMap;
export type SectorConfig = Mc2SectorConfigMap[keyof Mc2SectorConfigMap];
export type SectorConfiguration<T extends keyof Mc2SectorConfigMap> = Mc2SectorConfigMap[T];

export const JammingCommandTypeMap = {
  [SensorTypeEnum.MAJES]: Mc2CommandEnum.MajesJamming,
  [SensorTypeEnum.DFB6]: Mc2CommandEnum.Dfb6Jamming,
  [SensorTypeEnum.BLAST]: Mc2CommandEnum.BlastJamming,
};
